import { useMutation } from '@apollo/client';
import React, { useState } from 'react';
// import TextInput from '../../../components/input';
import ModalFormComp from '../../../../../components/ModalFormComp';
// import useForm from '../../../customHooks/useForm';
import useToast from '../../../../../customHooks/useToast';
import { PROCESS_SINGLE_SCHEDULE } from '../../../../../graphql/admin_mutations';
import TriggerModalIcon from '../../../../../svgs/TriggerModalIcon';

interface ITriggerComp{
  closeModal?:any;
  loanScheduleId?:string;
  fetchLoan?:any;
}
const TriggerComp = ({ closeModal, loanScheduleId, fetchLoan }:ITriggerComp) => {
  const Toast = useToast();
  const [loading, setLoading] = useState(false);
  const [processSingleLoanSchedule] = useMutation<
  { processSingleLoanSchedule : any },
  any
  >(PROCESS_SINGLE_SCHEDULE);

  const handleConfirmActivation = async () => {
    setLoading(true);
    if (!loading) {
      try {
        const result = await processSingleLoanSchedule({
          variables: {
            loanScheduleId,
          },
        });
        if (result?.data?.processSingleLoanSchedule?.status === 200) {
          fetchLoan?.();
          setLoading(false);
          Toast.success(result?.data?.processSingleLoanSchedule?.message || 'Operation was successful');
        } else {
          setLoading(false);
          Toast.error(result?.data?.processSingleLoanSchedule?.message || 'Operation Failed');
        }
      } catch (error) {
        setLoading(false);
        Toast.error('Operation failed');
      }
    }
  };

  return (
    <div>
      <ModalFormComp cancelActionBtn={closeModal} confirmationBtnContent={loading ? 'Confirm...' : 'Confirm'} closeModal={closeModal} removeTitle modalType="admin-confirmation-modal" confirmActionBtn={handleConfirmActivation} btnLoading={loading} confirmationIcon={<TriggerModalIcon />} confirmationSubTitle="Are you sure you want to proceed with this operation?" confirmationTitle="Trigger Payment" />
    </div>
  );
};
export default TriggerComp;
